import { Avatar } from '@mui/material'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import styles from './index.module.scss'
import { formatCommonDate } from '../../../util/formatDateAndTime'
import { formatCommonAmount } from '../../../util/formatAmount'

// 🔹 Map status to SCSS class
const cardStatusMap = {
	Completed: 'completed',
	Accepted: 'in-progress',
	Rejected: 'declined',
	Pending: 'pending',
	recieved: 'pending',
}

export default function CardView(props) {
	const cardStatusClass = cardStatusMap[props.statusLabel] || ''

	return (
		<div className={styles.cardView}>
			{/* Header */}
			<div className={styles.cardHead}>
				<div className={styles.cardHeadLeft}>
					<figure className={styles.cardImage}>
						<Avatar src={props.image} alt={props.title} />
					</figure>
					<div className={styles.cardHeadText}>
						<h2>{props.title}</h2>
						<div className={styles.cardHeadTextSub}>
							<p>
								<img
									src="/images/calendar.svg"
									alt="Calendar"
								/>{' '}
								<span>{formatCommonDate(props.date)}</span>
							</p>
							{props.guestCount && props.isStaff ? (
								<p>
									<img
										src="/images/profile-2user.svg"
										alt="People"
									/>{' '}
									<span>{props.guestCount} Guests</span>
								</p>
							) : (
								<></>
							)}
						</div>
					</div>
				</div>
			</div>

			{/* Body */}
			<div
				className={`${styles.cardBodyMain} ${!props.isStaff ? '' : styles.noDescription}`}
			>
				{props.description && !props.isStaff ? (
					<div className={styles.cardBody}>
						<span>{props.description}</span>
					</div>
				) : (
					<></>
				)}

				{/* Footer */}
				<div className={styles.cardFooter}>
					{props.budget ? (
						<p>Budget: {formatCommonAmount(props.budget)}</p>
					) : (
						<></>
					)}
					<div className={styles.cardFooterBtn}>
						{props.statusLabel === 'recieved' && !props.isStaff ? (
							<>
								<ButtonCustom
									data-cy="confirm-wedding"
									variant="approve"
									size="lg"
									onClick={props.onAccept}
								>
									Accept
								</ButtonCustom>
								<ButtonCustom
									data-cy="reject-wedding"
									variant="destructive"
									size="lg"
									onClick={props.onReject}
								>
									Decline
								</ButtonCustom>
							</>
						) : (
							<ButtonCustom
								data-cy="viewdetail"
								variant="outlined"
								size="lg"
								onClick={props.onViewDetail}
							>
								View Detail
							</ButtonCustom>
						)}
					</div>
				</div>
			</div>

			{/* Status */}
			{props.statusLabel ? (
				<div
					className={`${styles.cardStatus} ${
						styles[cardStatusClass]
					}`}
				>
					<p>{cardStatusClass}</p>
				</div>
			) : (
				<></>
			)}
		</div>
	)
}
